import { IFeatureToggle } from "../../redux/slices/feature-toggles";
import { FeatureToggleName } from "./types";
import { useSelectorTyped } from "../../redux/store";

export const useGetFeatureToggleState = (toggleName: FeatureToggleName): boolean => {
  const featureTogglesPEV = useSelectorTyped((state) => state.featureTogglesPEV);
  const filteredToggle = featureTogglesPEV.value.find((toggle: IFeatureToggle) => toggle.name === toggleName);
  return filteredToggle?.enabled ?? false;
};
